// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root * {
  transition-duration: 0.2s;
  transition-property: color, background, filter;
}

#container[data-theme='light'] {
  /* background colors */
  --primary-bg-color: #ffffff;
  /* primary colors */
  --primary-color-a: #062360;
  --primary-color-b: #231f20;
  /* secondary colors */
  --secondary-color-a: #0063a6;
  --secondary-color-b: #009898;
  /* neutral colors */
  --neutral-color-a: #6d6e70;
  /* semantic colors */
  --semantic-success-color: #22b170;
  --semantic-error-color: #d20000;
  --semantic-warning-color: #fa9a3c;
  /* primary color a shades */
  --primary-color-a-0: #95b5f8;
  --primary-color-a-0-5: #87a6e9;
  --primary-color-a-1: #7898da;
  --primary-color-a-1-5: #6a89ca;
  --primary-color-a-2: #5c7bbb;
  --primary-color-a-3: #3f5d9d;
  --primary-color-a-4: #23407e;
  --primary-color-a-5: #062360;
  --primary-color-a-6: #051c4d;
  --primary-color-a-7: #04153a;
  --primary-color-a-8: #020e26;
  /* primary color b shades */
  --primary-color-b-0: #b9b0b3;
  --primary-color-b-0-5: #aaa1a4;
  --primary-color-b-1: #9b9396;
  --primary-color-b-1-5: #8c8487;
  --primary-color-b-2: #7d7678;
  --primary-color-b-3: #5f595b;
  --primary-color-b-4: #413c3d;
  --primary-color-b-5: #231f20;
  --primary-color-b-6: #1c191a;
  --primary-color-b-7: #151313;
  --primary-color-b-8: #0e0c0d;
  /* secondary color a shades */
  --secondary-color-a-0: #cfecff;
  --secondary-color-a-0-5: #badef6;
  --secondary-color-a-1: #a6d1ed;
  --secondary-color-a-1-5: #91c3e4;
  --secondary-color-a-2: #7cb5db;
  --secondary-color-a-3: #539aca;
  --secondary-color-a-4: #297eb8;
  --secondary-color-a-5: #0063a6;
  --secondary-color-a-6: #004f85;
  --secondary-color-a-7: #003b64;
  --secondary-color-a-8: #002842;
  /* secondary color b shades */
  --secondary-color-b-0: #c1ffff;
  --secondary-color-b-0-5: #aef5f5;
  --secondary-color-b-1: #9aeaea;
  --secondary-color-b-1-5: #87e0e0;
  --secondary-color-b-2: #74d6d6;
  --secondary-color-b-3: #4dc1c1;
  --secondary-color-b-4: #27adad;
  --secondary-color-b-5: #009898;
  --secondary-color-b-6: #007a7a;
  --secondary-color-b-7: #005b5b;
  --secondary-color-b-8: #003d3d;
  /* neutral color a shades */
  --neutral-color-a-0: #ffffff;
  --neutral-color-a-0-5: #f0f0f1;
  --neutral-color-a-1: #e2e2e2;
  --neutral-color-a-1-5: #d3d3d4;
  --neutral-color-a-2: #c5c5c6;
  --neutral-color-a-3: #a7a8a9;
  --neutral-color-a-4: #8a8b8d;
  --neutral-color-a-5: #6d6e70;
  --neutral-color-a-6: #57585a;
  --neutral-color-a-7: #414243;
  --neutral-color-a-8: #2c2c2d;
  /* other shades */
  --other-shade-c-2: #f1f3f7;
  /* utils */
  --asec-atrad-bg: #95B5F8;
}
`, "",{"version":3,"sources":["webpack://./src/styles/themes.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,0BAA0B;EAC1B,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":["#root * {\n  transition-duration: 0.2s;\n  transition-property: color, background, filter;\n}\n\n#container[data-theme='light'] {\n  /* background colors */\n  --primary-bg-color: #ffffff;\n  /* primary colors */\n  --primary-color-a: #062360;\n  --primary-color-b: #231f20;\n  /* secondary colors */\n  --secondary-color-a: #0063a6;\n  --secondary-color-b: #009898;\n  /* neutral colors */\n  --neutral-color-a: #6d6e70;\n  /* semantic colors */\n  --semantic-success-color: #22b170;\n  --semantic-error-color: #d20000;\n  --semantic-warning-color: #fa9a3c;\n  /* primary color a shades */\n  --primary-color-a-0: #95b5f8;\n  --primary-color-a-0-5: #87a6e9;\n  --primary-color-a-1: #7898da;\n  --primary-color-a-1-5: #6a89ca;\n  --primary-color-a-2: #5c7bbb;\n  --primary-color-a-3: #3f5d9d;\n  --primary-color-a-4: #23407e;\n  --primary-color-a-5: #062360;\n  --primary-color-a-6: #051c4d;\n  --primary-color-a-7: #04153a;\n  --primary-color-a-8: #020e26;\n  /* primary color b shades */\n  --primary-color-b-0: #b9b0b3;\n  --primary-color-b-0-5: #aaa1a4;\n  --primary-color-b-1: #9b9396;\n  --primary-color-b-1-5: #8c8487;\n  --primary-color-b-2: #7d7678;\n  --primary-color-b-3: #5f595b;\n  --primary-color-b-4: #413c3d;\n  --primary-color-b-5: #231f20;\n  --primary-color-b-6: #1c191a;\n  --primary-color-b-7: #151313;\n  --primary-color-b-8: #0e0c0d;\n  /* secondary color a shades */\n  --secondary-color-a-0: #cfecff;\n  --secondary-color-a-0-5: #badef6;\n  --secondary-color-a-1: #a6d1ed;\n  --secondary-color-a-1-5: #91c3e4;\n  --secondary-color-a-2: #7cb5db;\n  --secondary-color-a-3: #539aca;\n  --secondary-color-a-4: #297eb8;\n  --secondary-color-a-5: #0063a6;\n  --secondary-color-a-6: #004f85;\n  --secondary-color-a-7: #003b64;\n  --secondary-color-a-8: #002842;\n  /* secondary color b shades */\n  --secondary-color-b-0: #c1ffff;\n  --secondary-color-b-0-5: #aef5f5;\n  --secondary-color-b-1: #9aeaea;\n  --secondary-color-b-1-5: #87e0e0;\n  --secondary-color-b-2: #74d6d6;\n  --secondary-color-b-3: #4dc1c1;\n  --secondary-color-b-4: #27adad;\n  --secondary-color-b-5: #009898;\n  --secondary-color-b-6: #007a7a;\n  --secondary-color-b-7: #005b5b;\n  --secondary-color-b-8: #003d3d;\n  /* neutral color a shades */\n  --neutral-color-a-0: #ffffff;\n  --neutral-color-a-0-5: #f0f0f1;\n  --neutral-color-a-1: #e2e2e2;\n  --neutral-color-a-1-5: #d3d3d4;\n  --neutral-color-a-2: #c5c5c6;\n  --neutral-color-a-3: #a7a8a9;\n  --neutral-color-a-4: #8a8b8d;\n  --neutral-color-a-5: #6d6e70;\n  --neutral-color-a-6: #57585a;\n  --neutral-color-a-7: #414243;\n  --neutral-color-a-8: #2c2c2d;\n  /* other shades */\n  --other-shade-c-2: #f1f3f7;\n  /* utils */\n  --asec-atrad-bg: #95B5F8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
